import safeCreateAction from "../../../actions/safeCreateAction";
export const setDeploymentNecessary = safeCreateAction("SET_NEED_DEPLOYMENT", (gameId, required) => ({ gameId, required }));
